<template>
    <div class="item" :class="{active : open }">
        <button class="btn-toggle" @click="open = !open">{{ title }} <i class="icon-arrow-toggle"></i></button>

        <vue-slide-toggle :open="open" tag="section" :duration="500">
            <div class="desc" v-html="content"></div>
        </vue-slide-toggle>
    </div>
</template>

<script>
import {VueSlideToggle} from 'vue-slide-toggle'

export default {
    name: "CollapseContentBlockWithTitle",

    components: {
        VueSlideToggle
    },

    props: ['componentContent'],

    data() {
        return {
            open: false,
        }
    },

    computed: {
        title() {
            return this.componentContent && this.componentContent.title;
        },

        content() {
            return this.componentContent && this.componentContent.content;
        },
    },
}
</script>

<style lang="sass" scoped>
@import "sass/components/pages/parts/contents/CollapseContentBlockWithTitle"
</style>